// extracted by mini-css-extract-plugin
module.exports = {"top":"Top_top__Vtzyt","icon":"Top_icon__3OCvL","right":"Top_right__219MD"};